import React, { useState } from "react";
import { Box, Paper, Typography } from "@material-ui/core";
import {
  FormActionDrawer,
  IntroText,
  Sheet,
  SheetContent
} from "../../components";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const GGVScheduleNoSlots = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [drawerClearance, setDrawerClearance] = useState(0);

  return (
    <>
      <Sheet
        data-cy="ggv-schedule-no-slots-view"
        style={{ paddingBottom: `${drawerClearance}px` }}
      >
        <SheetContent>
          <Box mb={2}>
            <Paper>
              <Box p={2}>
                <IntroText>{t("schedule.no_slots.intro_text")}</IntroText>
                <Typography align="center">
                  {t("schedule.no_slots.secondary_text")}
                </Typography>
              </Box>
              <FormActionDrawer
                handleNext={() => history.push("/")}
                setDrawerClearance={setDrawerClearance}
                nextButtonLabel={t("schedule.no_slots.button")}
              />
            </Paper>
          </Box>
        </SheetContent>
      </Sheet>
    </>
  );
};

export { GGVScheduleNoSlots };
